(() => {
const GRID_SEL = 'ul#product-grid, ul[id^="product-grid"], .product-grid';
const qp = new URLSearchParams(location.search);
let rawFirst = (qp.get('first') || '').trim();
if (!rawFirst) return;
let firstHandle = '';
let variantFromURL = '';
if (rawFirst.startsWith('http')) {
try {
const u = new URL(rawFirst);
const segs = u.pathname.split('/').filter(Boolean);
if (segs[0] === 'products' && segs[1]) firstHandle = segs[1];
variantFromURL = u.searchParams.get('variant') || '';
} catch (_) {}
} else {
const segs = rawFirst.split('/').filter(Boolean);
firstHandle = segs.pop();
}
if (!firstHandle) return;
const rawVariant = qp.get('variant') || variantFromURL;
const variantID = /^\d+$/.test(rawVariant) ? rawVariant : '';
let source = (qp.get('source') || '').trim();
if (!source) {
const p = location.pathname.split('/').filter(Boolean);
if (p[0] === 'collections' && p[1]) source = p[1];
}
if (!source) return;
const limit = Math.max(1, parseInt(qp.get('limit') || '24', 10));
const grid = document.querySelector(GRID_SEL);
if (!grid) return;
const previewExtras = (() => {
const list = [];
['preview_theme_id', 'preview_theme_token', 'pb'].forEach(k => {
if (qp.has(k)) list.push(`${k}=${encodeURIComponent(qp.get(k) || '')}`);
});
return list.join('&');
})();
const appendPreview = url =>
previewExtras ? (url.includes('?') ? `${url}&${previewExtras}` : `${url}?${previewExtras}`) : url;
const aspect = (grid.getAttribute('data-aspect') || '').toLowerCase();
const view = aspect === 'square' ? 'card-square' : aspect === 'portrait' ? 'card-portrait' : 'card';
const fetchCard = async (handle, variant = '') => {
const url = appendPreview(`/products/${encodeURIComponent(handle)}?view=${view}${variant ? `&variant=${variant}` : ''}`);
try {
const r = await fetch(url);
return r.ok ? await r.text() : '';
} catch(e) { return ''; }
};
const render = html => { if (html.trim()) grid.insertAdjacentHTML('beforeend', html); };
(async () => {
// 1. Pinned Card
const pinnedHTML = await fetchCard(firstHandle, variantID);
grid.innerHTML = '';
if (pinnedHTML) render(pinnedHTML);
// 2. Collection Handles (JSON)
const handlesURL = `/collections/${encodeURIComponent(source)}/products.json?limit=250`;
let restHandles = [];
try {
const response = await fetch(handlesURL);
if (response.ok) {
const data = await response.json();
const allHandles = (data.products || []).map(p => p.handle);
const seen = new Set([firstHandle]);
for (const h of allHandles) {
if (h && !seen.has(h)) {
seen.add(h);
restHandles.push(h);
}
if (restHandles.length >= (limit - 1)) break;
}
}
} catch (e) { console.error('Curated Grid: Source fetch failed', e); }
// 3. Render Rest
if (restHandles.length > 0) {
const cards = await Promise.all(restHandles.map(h => fetchCard(h)));
cards.forEach(render);
}
// 4. Mobile-Ready Variant Swap
if (variantID && pinnedHTML) {
try {
const prod = await fetch(`/products/${firstHandle}.js`).then(r => r.json());
const varObj = prod.variants.find(v => String(v.id) === variantID);
if (varObj && varObj.featured_image) {
const newSrc = varObj.featured_image.src;
const pinnedLi = grid.querySelector('li.grid__item:first-child');
if (pinnedLi) {
pinnedLi.querySelectorAll('img').forEach(img => {
img.removeAttribute('srcset');
img.removeAttribute('data-srcset');
img.src = newSrc;
if (img.dataset.src) img.dataset.src = newSrc;
});
pinnedLi.querySelectorAll('a[href*="/products/"]').forEach(a => {
const u = new URL(a.href, location.origin);
u.searchParams.set('variant', variantID);
a.href = u.pathname + u.search;
});
}
}
} catch (e) { /* Silent fail for variant swap */ }
}
// 5. Final Count Update
const count = grid.querySelectorAll('.grid__item').length;
document.querySelectorAll('[data-product-count], .product-count, .collection-product-count')
.forEach(el => el.textContent = `${count} Products`);
})().catch(err => { console.error('Curated Grid: Global error', err); });
})();